import React from "react";
import ReactDOM from "react-dom";
import HexModal from "../../../app/components/modals/HexModal";
import { findModels } from "../../../infrastructure/repository/benefit-models-repository";
import {
  findCompanyId,
  findCompanyDetail,
} from "../../../infrastructure/repository/company-repository";
import { findEmployeeDetail } from "../../../infrastructure/employees-cache";
import ShowDetailEmployee from "../../../app/components/modals/employee/showDetailEmployee";
import { showErrorMessage } from "../../commons/show-error-message";
import Employee from "../../../app/domain/Employee";
import { logError, addContextLog } from "../../../infrastructure/log";
import { translate } from "../../../infrastructure/translate/localization";
import { shouldFilterTaxRegimes } from "../../../infrastructure/country-rules";

function renderEmployeeModal({
  employee,
  benefitModels,
  errors,
  taxRegimes,
  currentPage,
}) {
  ReactDOM.render(
    <HexModal>
      <ShowDetailEmployee
        employee={employee}
        benefitModels={benefitModels}
        taxRegimes={taxRegimes}
        errors={errors}
        currentPage={currentPage}
        editType="editEmployee"
      />
    </HexModal>,
    document.getElementById("modal-container")
  );
}

export async function displayEmployeeDetails({
  employeeId,
  errors = null,
  currentPage = 1,
}) {
  try {
    const companyId = await findCompanyId();
    const companyDetail = await findCompanyDetail();
    const employee = await findEmployeeDetail({ companyId, employeeId });
    const { data: benefitModels } = await findModels();

    addContextLog("info", "displayEmployeeDetails", "display-screen", {
      companyId,
      employee,
      benefitModels,
      errors,
    });
    renderEmployeeModal({
      employee,
      benefitModels,
      errors,
      taxRegimes: shouldFilterTaxRegimes(companyDetail.data.countryISO2Code)
        ? [Employee.taxRegimes[0]]
        : Employee.taxRegimes,
      currentPage,
    });
  } catch (e) {
    logError(e, `Error to displayEmployeeDetails with employee ${employeeId}`);
    showErrorMessage(translate("common-messages.basic-error-message"), true, e);
  }
}
